export const PICK_TASK_ROUTE_ROOT = '/pick-task';

export const PICK_TASK_ROUTES = {
  PICK_TASK: PICK_TASK_ROUTE_ROOT,
  ASSIGN: `${PICK_TASK_ROUTE_ROOT}/assign`,
  LIST: `${PICK_TASK_ROUTE_ROOT}/list`,
  ITEM: `${PICK_TASK_ROUTE_ROOT}/item`,
  SUMMARY: `${PICK_TASK_ROUTE_ROOT}/summary`,
} as const;
